import { environment } from './environment';
import { NdtEnvironment } from './environment.interface';
import { EnvironmentService } from './environment.service';

export class NdtEnvironmentService extends EnvironmentService<NdtEnvironment> {
   environment: NdtEnvironment = environment;
}
